export const GRADIENTS_ACTION_TYPES = {
    SET_STATUS: 'gradients/SET_STATUS',
    SET_ADD_TO_CART_STATUS: 'gradients/SET_ADD_TO_CART_STATUS',
    SET_DISPLAYED_GRADIENT: 'gradients/SET_DISPLAYED_GRADIENT',
    SET_DEFAULT_GRADIENT: 'gradients/SET_DEFAULT_GRADIENT',
    SET_GRADIENT_A: 'gradients/SET_GRADIENT_A',
    SET_GRADIENT_B: 'gradients/SET_GRADIENT_B',
};